import { ComponentStyleConfig } from "@chakra-ui/react";

export const checkboxStyle: ComponentStyleConfig = {
  variants: {
    blueLite: {
      control: {
        bg: "#fff",
        mb: 0,
        borderColor: "#000000",
        _checked: {
          borderColor: "#1795FE",
          bg: "#1795FE",
          _hover: {
            bg: "#1795FE !important",
            borderColor: "#1795FE !important",
          },
        },
      },
    },
    blue: {
      control: {
        bg: "#fff",
        mb: 0,
        _checked: {
          borderColor: "transparent",
          bg: "#1795FE",
          _hover: {
            bg: "#1795FE !important",
            borderColor: "#1795FE !important",
          },
        },
      },
    },
    black: {
      control: {
        bg: "#fff",
        mb: 0,
        borderColor: "#000000",
        _checked: {
          borderColor: "#000000",
          bg: "#000000",
          _hover: {
            bg: "#000000 !important",
            borderColor: "#000000 !important",
          },
        },
      },
    },
  },
  sizes: {
    lg: {
      control: {
        w: "1.8rem",
        h: "1.8rem",
        borderRadius: "4px",
        borderColor: "#A3A3A3",
        _checked: {
          bg: "#009BE0",
        },
      },
      label: { fontSize: "1.4rem", fontWeight: "normal", ml: "1rem" },
      icon: { fontSize: "1rem" },
    },
  },
  defaultProps: {
    size: "lg",
    colorScheme: "blue",
  },
};
